import { supabase } from './supabaseClient';
import { buildActorName } from './actorName';

/**
 * Wer gerade angemeldet ist — Id und Anzeigename fuer Spalten wie
 * `hochgeladen_von_name`, `erstellt_von_name`, `entschieden_von_name`.
 *
 * Ablage, Ausgaben und Fassungsentscheide geschehen aus einer Freigabe, einem
 * Versand oder einer Bewertung heraus, und spaeter soll ablesbar sein, wer das
 * ausgeloest hat. Scheitert die Abfrage (kein Nutzer, Profil nicht lesbar,
 * Ersatz-Client ohne `getUser`), bleiben beide Felder leer — der Schreibweg
 * selbst darf daran nie haengen. Wirft NIE.
 */
export interface AngemeldeterBenutzer {
  id: string | null;
  name: string | null;
}

const NIEMAND: AngemeldeterBenutzer = { id: null, name: null };

export const angemeldeterBenutzer = async (): Promise<AngemeldeterBenutzer> => {
  try {
    const auth = supabase.auth as { getUser?: () => Promise<{ data?: { user?: { id?: string } | null } }> };
    if (typeof auth?.getUser !== 'function') return NIEMAND;
    const { data } = await auth.getUser();
    const id = data?.user?.id || null;
    if (!id) return NIEMAND;
    const { data: profil } = await supabase
      .from('profiles')
      .select('first_name, last_name')
      .eq('id', id)
      .maybeSingle();
    return { id, name: buildActorName(profil as { first_name?: string | null; last_name?: string | null } | null) || null };
  } catch {
    return NIEMAND;
  }
};
